module.exports = __webpack_public_path__ + "static/img/CH.5852bb73.jpg";